<template>
<div>

<alert-box class="mt-1" @close="msg.title=''" v-bind:msg="msg"  ></alert-box>  
<form id="formMain" v-on:submit.prevent="submit()" >

 
  <div class="card " > 
  <div class="card-header text-white bg-info">
    <h4>
    <i class="fas fa-print mr-2" aria-hidden="true"></i>
    RESO A FORNITORE - STAMPA </h4>
  
  </div>
  <div class="card-body">
    
                <div class="form-row">
                <div class="form-group col-md-4">
                <label for="doc_type"><strong>Tipo documento</strong></label>
                <select required v-model="packing.typeId" class="form-control" id="doc_type">
                    <!--<option value="1">Fattura</option>-->
                    <option value="2">DDT</option>
                </select>
                </div>
                <div class="form-group col-md-4">
                  <label for="number_doc"><strong>Numero documento</strong></label>
                  <input v-focus v-model="packing.number" type="text" class="form-control " placeholder="" name="number_doc" id = "number_doc" required>
                </div>
                <div class="form-group col-md-4">
                  <label for="date_doc"><strong>Data documento</strong></label>
                  <input required v-model="packing.date" type="date" class="form-control" placeholder="" name="date_doc" id = "date_doc">
                </div>
                </div>
                <div class="form-row">
                <div class="form-group  col-md-6">
                  <label for="number_doc"><strong>Numero colli</strong></label>
                  <input v-model="packing.total_packages" type="text" class="form-control " placeholder=""  required>
                </div>
                <div class="form-group  col-md-6">
                  <label for="doc_appearance"><strong>Aspetto beni</strong></label>
                  <input v-model="packing.appearance" type="text" class="form-control " placeholder=""  required>
                </div>
                </div>
                <div class="form-group">
                  <label for="number_doc"><strong>Destinazione</strong></label>
                  <input v-model="packing.destination" type="text" class="form-control" placeholder=""  required>
                </div>
                <div class="form-group">
                  <label for="doc_reference"><strong>Riferimento</strong></label>
                  <input v-model="packing.reference" type="text" class="form-control" placeholder=""  required>
                </div>

                 <shipper-select v-bind:props="shipper"  @update="setShipperId" :key="refresh"></shipper-select>

                  
                  <div v-if="headings.length>1" >
                  
                  <label  for="heading"><strong>INTESTAZIONE DDT</strong></label>  
                  <select  class="form-control mb-3" v-model="rowId">                        
                    <option v-for="(item,index) in headings" :value="item.rowId" :key="index">
                    {{item.heading1}}</option>                            
                  </select> 

                  </div>
                  
                  


                  <div class="form-group float-right">

                  <div class="form-check ">
                    <input class="form-check-input" type="checkbox" id="gridCheck1" v-model="packing.total">
                    <label class="form-check-label" for="gridCheck1">
                      <strong>Valorizza DDT</strong>
                    </label>
                  </div>
                  <div class="form-check ">
                    <input class="form-check-input" type="checkbox" id="gridCheck2" v-model="packing.shipping_date">
                    <label class="form-check-label" for="gridCheck2">
                      <strong>Stampa data e ora</strong>
                    </label>
                  </div>
                  
                  <button type="submit"  class="btn btn-success mt-3" >
                    <i class="fas fa-print mr-2" aria-hidden="true"></i>
                    STAMPA
                    <span v-if="spinner"  class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                  </button>
                  </div>
                 
                
  </div>
 </div>

      </form>


 <div v-if="progress>0" class="progress">
        <div class="progress-bar progress-bar-striped" role="progressbar"  :style="{'width':getProgress}">
          {{ progress }}%
        </div>
</div>


</div>
</template>
<script>


import api              from '@/api';
import alertBox         from '@/components/common/AlertBox.vue';
import shipperSelect    from '@/components/common/ShipperSelect.vue';
import jsPDF            from 'jspdf'
import { mapGetters }   from 'vuex';


export default {
  
  components: {alertBox,shipperSelect
  
  
  },  
  props: ['documentId','movementId'],
 
 data () {
    return {
      

      shipper        : 
      {
        Id            : 0,
        isActive      : true,
       
        //optionBase    : true,
        required      : true
      },
      
      

      packing         : {
        typeId        : 2
      },
      
      alert           : false,
      spinner         : false,
     
      msg             : {
          
         title : '',
         body  : '',
         type  : 0
      },
      refresh         : 0,
      headings        : [],
      rowId           : 0,
      progress        : 0
      
      

    }
  },

computed: 
  {

    ...mapGetters(['storeId','company']) , 

   getProgress()
  {
    let p = this.progress
    return p + "%";
  }
  },
   directives: {
    focus: {
      // directive definition
      inserted: function(el) {
        el.focus();
      }
    }
  },
mounted()
{   
    
   
},
created()
{ 
  
  if(this.documentId>0)
  {
    this.getData()
  }  
},

methods: 
{
    setShipperId(Id,e)
    {
      
      this.packing.shipperId = Id
      
    },
    async getData()
    {
       
        this.msg.title = ''
        const data = {'movementId':this.movementId,'companyId':this.company.Id}

        const sp   = {'sp'         : 'spPackingSlip'}
        const json = Object.assign(data, sp);
       
        this.spinner = true
        await api.post(json).then(res => {
                   
          if(res.status == 200)
            {
                            
              

              this.headings = res.data.recordsets[1]
              if(this.headings.length> 0)
              {
                this.rowId = res.data.recordsets[1][0].rowId
              }
              
              if(res.data.recordsets[0].length > 0 )
              {
                
                this.packing = res.data.recordsets[0][0]  
                this.shipper.Id = this.packing.shipperId
                this.refresh++
                                               

              }
              

            }
           else if(res.status == 500)
           {
                                          
              this.msg.title = 'ATTENZIONE '
              this.msg.body = res.data
              this.msg.type = 1
                    
           } 
           else
            {
                             
              this.msg.title =  'ATTENZIONE '
              this.msg.body = res
              this.msg.type = 1               
                 
            } 
          
          }).catch(err => {
                           
              this.msg.title =  'ATTENZIONE '
              this.msg.body = err.message
              this.msg.type = 1                 
              
          }).finally(() => {
              this.spinner = false
        });


	},
  
   
        
  async submit() 
  {
    
   
    this.spinner = true
    const data  = {'documentId':this.documentId,'number':this.packing.number,'date':this.packing.date,'typeId':2,'movementId':this.movementId,'isSupplier':1}       
    const sp    = {'sp':'spCreatePackingSlip'}
    const json  = Object.assign(data, sp,this.packing);

    await api.post(json).then(res => {
          
          if(res.status == 200)
            {
              
              this.getDataToPrint()
              //this.$emit('update',this.doc)  

            }
           else if(res.status==500)
           {
                          
              this.msg.title = 'ATTENZIONE '
              this.msg.body = res.data
              this.msg.type = 1                
                    
           } 
           else
            {
                           
              this.msg.title = 'ATTENZIONE '
              this.msg.body = res
              this.msg.type = 1 
            } 
          
          }).catch(err => {
                           
              this.msg.title = 'ATTENZIONE '
              this.msg.body = err.message
              this.msg.type = 1 
              
          }).finally(() => {
          this.spinner = false
        });



	},
  async getDataToPrint()
      {
        
        this.spinner = true                
        var data  = {'movementId' : this.movementId,'companyId' : this.company.Id}
        
        var sp    = {'sp' : 'spPackingSlipPDF'}
        var json  = Object.assign(data, sp);

        await api.post(json).then(res => {
          
          if(res.status==200)
            { 
              

              let headings = this.headings.filter(item => item.rowId == this.rowId)
              this.printPDF(res.data.recordsets,headings)

              
            }
           else if(res.status==500)
           {
                console.log(res.data)

                
                    
           } 
           else
            {
                console.log('Network Error.')                  
                 
            } 
          

          }).catch(err => {
              
              console.log(err.message)    

              
          }).finally(() => {
          this.spinner = false
        });

  
      },

  
    fmt(value,fmt)
    { 
      if(!isNaN(value))
      {
      return Number(value).toLocaleString('it-IT',{ style: 'decimal',minimumFractionDigits: fmt ,maximumFractionDigits: fmt});
      }
    },
     
    async printPDF(items,headings)
    {
      let _this = this
      function wait(ms) 
      {
          return new Promise(resolve => {
          setTimeout(() => { resolve('') },ms);
          })
      }
      
      let r           = 0
      let last_row    = 268
      let grandTotal1 = 0
      let grandTotal2 = 0
      
      const doc = new jsPDF()

      var page         = 1            
      var row_index    = 1      
      var init_row     = 80
      var row          = init_row
     
      var col          = 3
      var col1         = 17
      var col2         = 47
      var col3         = 107
      var col4         = 137
      var col5         = 177
      var col6         = 205
      
     
      var header = function()
      {

      // SENDER    
      doc.setDrawColor(51,0,0)        
      doc.setFillColor(232,232,232)          
      doc.roundedRect(2, 5, 100, 25,2,2,'FD')

      doc.setFontSize(6)
      doc.text('Cedente'  ,5,8)
            
      if(headings.length > 0)
      {          
        doc.setFontSize(12)
        doc.setFont("helvetica", "bold")
        doc.text(headings[0].heading1  ,4,14)        
        doc.setFont("helvetica", "normal")
        doc.setFontSize(10)
        doc.text(headings[0].heading2  ,4,18)        
        doc.text(headings[0].heading3  ,4,22)        
        doc.text(headings[0].heading4  ,4,26)               
      }
      

      // SUPPLIER
      doc.setDrawColor(51,0,0)        
      doc.setFillColor(232,232,232) 
      doc.roundedRect(108, 5, 100, 25,2,2,'FD')
      let xCol = 110    
      doc.setFontSize(6)
      doc.text('Cessionario'  ,xCol+1,8)
      doc.setFontSize(12)
      doc.text(items[1][0].supplier  ,xCol,13)      
      doc.setFontSize(10)
      doc.text(items[1][0].address  ,xCol,17)
      doc.text(items[1][0].postalCode + ' ' +  items[1][0].city ,xCol,21)
      doc.text(items[1][0].country  ,xCol,25)
      doc.text('P.iva ' + items[1][0].vat_number ,xCol,29)

      // PACKING 
      xCol = 50
      doc.setDrawColor(0,0,0)
      doc.setFillColor(0,0,0)
      doc.roundedRect(5, 32, 98, 28,2,2)    
      doc.setFontSize(12)      
      

      doc.text('D.D.T. N.RO' ,7,38)
      doc.setFont('helvetica', 'italic')
      doc.setFont("helvetica", "bold")
      doc.text(items[1][0].number.substr(0,6) +  ' del ' + items[1][0].create_at ,xCol,38)
      doc.setFont("helvetica",'normal')

      doc.text('NUMERO COLLI' ,7,43)
      doc.setFont('helvetica', 'italic')
      doc.text(items[2][0].total_packages.toString() ,xCol,43)            
      doc.setFont("helvetica",'normal')
      doc.text('ASPETTO BENI' ,7,48)
      doc.setFont('helvetica', 'italic')
      doc.text(items[2][0].appearance ,xCol,48)      
      doc.setFont("helvetica",'normal')
      doc.text('TOTALE QUANTITA\'' ,7,53)


      xCol = 110
      doc.roundedRect(108, 32, 100, 28,2,2)       
      doc.text('DESTINAZIONE' ,xCol,36)
      doc.setFont('helvetica', 'italic')
      doc.setFontSize(7)
      doc.text(items[2][0].destination.substr(0,68) ,xCol+1,39)
      doc.text(items[2][0].destination.substr(68,65) ,xCol+1,41.5)
      doc.setFont("helvetica",'normal')

      doc.setFontSize(12)
      doc.text('RIFERIMENTO' ,xCol,46)
      doc.setFont('helvetica', 'italic')
      doc.setFontSize(7)
      
      doc.text(items[2][0].reference.substr(0,68) ,xCol+1,49)
      doc.text(items[2][0].reference.substr(68,65) ,xCol+1,51.5)
      

      doc.setFont("helvetica",'normal')

      doc.setFontSize(12)
      
      doc.text('A MEZZO' ,xCol,56)
      doc.setFont('helvetica', 'italic')
      
      doc.setFontSize(8)
      doc.text(items[2][0].shipper ,xCol+1,59)

      doc.setFont("helvetica",'normal')

      doc.roundedRect(2, 70, 206, 222,1,1)  
      
      doc.line(2, 275, 208,275)

      doc.line(140, 292, 140, 275)
      doc.line(70, 292, 70, 275)
      doc.line(2, 270, 208,270)


      let d = new Date();
      let data = d.toLocaleString('it-IT',{dateStyle:'short',timeStyle:'short'});

      doc.text('Data e ora ' , 15,273) 
      
      if(_this.packing.shipping_date)
      {
        doc.setFontSize(12)
        doc.text(data , 15,280) 
        doc.setFontSize(8)
      }   
  
      doc.text('Firma vettore ' , 75,273)    
      doc.text('Firma destinatario ' , 145,273)    

    

      doc.line(2, init_row-3,208, init_row-3)
      doc.setFont("helvetica","bold");
      
        doc.setFontSize(10)
      
        doc.text('BRAND', col1,init_row -4);
        doc.text('CODICE', col2,init_row -4);
        doc.text('CATEGORIA', col3, init_row -4);
        doc.text('REPARTO', col4, init_row -4);
        doc.text("QUANTITA'", col5, init_row -4,{align:'right'});
        if(_this.packing.total)
        {
          doc.text('IMPORTO', col6, init_row -4,{align:'right'});
        }
                
        doc.setFont("helvetica","normal");
        

      }
      var footer = function(page,pages,total)
      {

      if(page == 1)
      { 
        doc.setFontSize(12)  
        doc.text(grandTotal1.toString() ,75,53)
        if(total)
        {
          doc.setFontSize(12) 
          doc.text('TOTALE EURO ' ,7,58)
          doc.text(grandTotal2.toLocaleString('it-IT',{ style: 'currency', currency: 'EUR' }) ,75,58)
        }  
      }
        
        doc.setPage(page)
        doc.roundedRect(108, 61, 100, 8,2,2)        
        doc.setFontSize(14)
        doc.text('Pagina ' + page.toString() + ' / ' + pages.toString(),  155, 67, null, null, "center");
        if(page < pages)
        {
          doc.setFontSize(14)
          doc.text('SEGUE ' , 155,285)    
          
        }
       
      }
      
      header()

      let j
      // MAIN LOOP
      for (j = 0; j < items[0].length; j++) {
      
      let item = items[0][j]
       
        r++  
        this.progress = Math.round(r / items.length * 100)
        await wait(0) 

        grandTotal1 += item.qty
        grandTotal2 += item.total

        
       
        if(row > last_row )
        {
          page++  
          doc.addPage("a4");
          row = init_row
          header()
        
        }
       
       doc.setFontSize(8)
       doc.text(row_index.toString(), col, row)
       doc.setFont("helvetica","bold")
       doc.text(item.brand.toString().substr(0,15), col1, row)
       doc.text(item.sku.toString().substr(0,30), col2, row)
       
       doc.text(item.category.toString().substr(0,50), col3, row) 
       doc.text(item.department.toString().substr(0,15), col4, row)       
       doc.text(item.qty.toString().substr(0,25), col5, row,{align:'right'})
       if(this.packing.total)
       {
        doc.text(this.fmt(item.total.toString().substr(0,25),2), col6, row,{align:'right'})
       }
       doc.setFont("helvetica","normal")

       row_index++ 
       row = row + 5

       if(row > last_row )
        {
          page++  
          doc.addPage("a4");
          header()
          row = init_row

         
        }

       let n    = col + 18
       let w    = 11.8 
       let cols =  JSON.parse(item.header)
       
       // HEADER COLS
       cols.forEach(col => {  
        doc.setFontSize(8) 
        doc.setFillColor(240,240,240)  
        
        doc.rect(n -1, row -3, w, 4,'FD');
        
        doc.text(col.size.toString().substr(0,6) , n, row);  
        n= n + w
       })
       
       let colors = JSON.parse(item.data)
       
       row = row + 5
       colors.forEach(color => {
       
        if(row > last_row )
        {
          page++  
          doc.addPage("a4")
          row = init_row + 1
          header()
           
        }

        // COLOR
        doc.setFontSize(8)
        if(color.color)
        {
          doc.text(color.color.toString().substr(0,9) , 5, row )
        }
        else
        {
          doc.text('MANCANTE' , 5, row )
        }
        
        let sizes  = color.s
        n = col + 18

        // SIZES
        cols.forEach(col =>{
          sizes.forEach(size=>{
            doc.setDrawColor(200,200,200)       
            doc.rect(n -1, row -3, w, 4)
            doc.setDrawColor(0)       
            if(col.size == size.size) 
            { 
              doc.text(size.qty.toString().substr(0,10) , n, row )
            } 

          })
          n = n + w 
        })
                  
        row = row + 4
       
       })

       row = row + 4
        
      }
      
      doc.setFontSize(10)
      
      doc.setPage(1)

    
      for (let i = 1; i <= page  ; i++) {
          footer(i,page,this.packing.total)
      }

      this.progress = 0
      let fileName = 'CheckList_' + Date.now().toString()
      window.open(doc.output('bloburl', { filename: fileName }), '_blank');
      
    },

   
  
      
}
    
}    
</script>

<style scoped>

 
.bold {
  font-weight: bolder;
}

h4 {
  font-family: 'Roboto Condensed';
  font-size: 20px;
}


.form-check-label
{
  cursor: pointer;
}
</style>